import { TaskAssigneePrivacyEnum } from '@/bundles/Tasks/types';

export const taskAssigneePrivacyLabels: Record<string, string> = {
  [TaskAssigneePrivacyEnum.me]: 'My Tasks',
  [TaskAssigneePrivacyEnum.by_me]: 'My Assignments',
  [TaskAssigneePrivacyEnum.my_team]: "My Team's Tasks",
}

// List sources whose page can create a task for the selected records (they render
// CreateTaskForm for the Actions menu's Add Task). Other lists -- press releases,
// signs, documents, requests, marketing and design-manager lists -- have no task
// form, so the menu must not offer the item there.
export const taskListSources: readonly string[] = Object.freeze([
  'property',
  'availability',
  'contact',
  'requirement',
  'company',
  'occupier',
  'comparable',
  'deal',
  'project',
  'pipeline',
]);
